import util from '../util'

const controller = 'Login'

export default {
  Login: (username, password) => {
    return util.Axios.Post(`${controller}/Login`, {
      login: username,
      senha: password
    })
  }
}



// WEBPACK FOOTER //
// ./src/_api/controllers/login.js